/*
 * @Description:系统公用接口
 * @Author: miaomiao
 * @Date: 2021-03-17 15:10:45
 * @LastEditTime: 2022-08-23 14:26:18
 * @LastEditors: JikeyChang
 */

import dbc from '@/api/common';

const listData = {
  namespaced: true,
  state: {
    /* 数据字典 */
    // 离职状态
    QUIT_STATUS: [],
    MOBILEAREA: [],
  },

  actions: {
    /**
     * 获取数据字典信息
     * @param {*} param
     */
    getDictionarySources({ commit }, param) {
      return dbc.getDictionarySources(param).then((content) => {
        content.type = param.typeCode;
        commit('setDictionarySources', content);
      });
    },
    /**
     * 选人组件
     */
    getListByNameOrDept(store, param) {
      return dbc.getListByNameOrDept(param);
    },
  },
  mutations: {
    setDictionarySources(state, content) {
      state[content.type] = content.list;
    },
  },
};
export default listData;
